import { createSelector } from 'reselect';
import * as fromState from '../../../reducers';
import { ENTITY_TYPE } from '../../../../utils/constants';

export const getCompareTrend = createSelector(
  [state => fromState.getAll(state, ENTITY_TYPE.TREND), fromState.getCompareTrend],
  (allTrends, id) => allTrends[id]
);